import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { API_ROOT } from "../../types/constants/appconstants";
import { DocumentUploadInfo } from "../../types/documentuploadinfo";
import { DocumentUploadModel } from "../../types";

/**
 * Staging upload APIs (plain HttpClient). Callers that show the global overlay should wrap
 * the full operation in SpinnerService (e.g. recordable save + upload in RecordableEditSaveService).
 */
@Injectable({
    "providedIn": "root"
})
export class DocumentsService {
    private http = inject(HttpClient);
    private documentsBaseUrl = inject(API_ROOT) + "api/documentManagement";

    uploadDocument(files: DocumentUploadInfo<object>[]): Observable<DocumentUploadModel[]> {
        return this.http.post<DocumentUploadModel[]>(`${this.documentsBaseUrl}/upload`, files);
    }

    uploadComplete(blobStagingIds: number[]): Observable<unknown> {
        return this.http.post(`${this.documentsBaseUrl}/uploadComplete`, blobStagingIds);
    }
}
